import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import Picklist from 'react-rainbow-components/components/Picklist';
import Option from 'react-rainbow-components/components/Option';
import MenuDivider from 'react-rainbow-components/components/MenuDivider';
import useReduxForm from 'react-rainbow-components/libs/hooks/useReduxForm';
import { useFirebaseApp } from '@rainbow-modules/firebase-hooks';
import useServiceLevels from './hooks/useServiceLevels';

function Options(_ref) {
  var _ref$serviceLevels = _ref.serviceLevels,
      serviceLevels = _ref$serviceLevels === void 0 ? [] : _ref$serviceLevels;
  return serviceLevels.map(function (service, index) {
    if (service === 'divider') {
      var key = "divider-".concat(index);
      return /*#__PURE__*/React.createElement(MenuDivider, {
        key: key
      });
    } // eslint-disable-next-line react/jsx-props-no-spreading


    return /*#__PURE__*/React.createElement(Option, service);
  });
}

export default function GroupServiceLevelPicker(props) {
  var _useReduxForm = useReduxForm(props),
      className = _useReduxForm.className,
      style = _useReduxForm.style,
      value = _useReduxForm.value,
      onChange = _useReduxForm.onChange,
      name = _useReduxForm.name,
      error = _useReduxForm.error,
      groupId = _useReduxForm.groupId,
      label = _useReduxForm.label,
      hideLabel = _useReduxForm.hideLabel,
      labelAlignment = _useReduxForm.labelAlignment,
      required = _useReduxForm.required,
      placeholder = _useReduxForm.placeholder,
      filterByUserId = _useReduxForm.filterByUserId,
      disabled = _useReduxForm.disabled,
      readOnly = _useReduxForm.readOnly;

  var app = useFirebaseApp();

  var _useServiceLevels = useServiceLevels({
    app: app,
    groupId: groupId,
    filterByUserId: filterByUserId
  }),
      _useServiceLevels2 = _slicedToArray(_useServiceLevels, 2),
      serviceLevels = _useServiceLevels2[0],
      isLoading = _useServiceLevels2[1];

  return /*#__PURE__*/React.createElement(Picklist, {
    name: name,
    label: label,
    labelAlignment: labelAlignment,
    hideLabel: hideLabel,
    required: required,
    placeholder: placeholder,
    enableSearch: !isLoading,
    isLoading: isLoading,
    value: value,
    error: error,
    onChange: onChange,
    className: className,
    style: style,
    disabled: disabled,
    readOnly: readOnly
  }, /*#__PURE__*/React.createElement(Options, {
    serviceLevels: serviceLevels
  }));
}
GroupServiceLevelPicker.defaultProps = {
  className: undefined,
  style: undefined,
  value: undefined,
  onChange: function onChange() {},
  error: undefined,
  groupId: undefined,
  label: undefined,
  hideLabel: false,
  labelAlignment: 'center',
  required: false,
  placeholder: undefined,
  name: undefined,
  disabled: false,
  readOnly: false,
  filterByUserId: undefined
};